import {
  AFFILIATED_EMPLOYEE_ID,
  AFFILIATED_EMPLOYEE_NAME,
  AFFILIATED_MEMBER_ID,
  AFFILIATED_MEMBER_NAME,
  B2B_ClASS_TYPE,
  IS_CUSTOMER,
  IS_B2B,
  B2BCLASSTYPE_B_ID,
  B2BCLASSTYPE_N_ID,
  B2C_ID,
  B2BCLASSTYPE_C_ID,
  GUEST_ID,
  B2BCLASSTYPE_E_ID,
  B2BCLASSTYPE_S_ID,
  B2BCLASSTYPE_B_ID_NAME,
  B2BCLASSTYPE_N_ID_NAME,
  B2C_ID_NAME,
  B2BCLASSTYPE_C_ID_NAME,
  B2BCLASSTYPE_E_NAME,
  B2BCLASSTYPE_S_NAME,
  IS_CALL_CENTER,
  IS_EMPLOYEE,
  STUDENT_ID,
  STUDENT_NAME,
  SUPPLIER_ID,
  SUPPLIER_NAME,
} from "./constants";
import { isAuthenticated } from "../lib/auth";

export const IS_CUSTOMER_VAL =
  isAuthenticated() &&
  localStorage.getItem(IS_CUSTOMER) &&
  localStorage.getItem(IS_CUSTOMER) === "yes"
    ? true
    : false;

export const IS_B2B_VAL =
  isAuthenticated() &&
  localStorage.getItem(IS_B2B) &&
  localStorage.getItem(IS_B2B) === "yes"
    ? true
    : false;

export const IS_CALLCENTER_VAL =
  isAuthenticated() &&
  localStorage.getItem(IS_CALL_CENTER) &&
  localStorage.getItem(IS_CALL_CENTER) === "yes"
    ? true
    : false;

export const IS_EMPLOYEE_VAL =
  isAuthenticated() &&
  localStorage.getItem(IS_EMPLOYEE) &&
  localStorage.getItem(IS_EMPLOYEE) === "yes"
    ? true
    : false;

export const CLASS_TYPE = localStorage.getItem(B2B_ClASS_TYPE)
  ? localStorage.getItem(B2B_ClASS_TYPE)
  : null;

export const IS_GUEST =
  !IS_CUSTOMER_VAL && !IS_B2B_VAL && !IS_CALLCENTER_VAL ? true : false;

export const CLASS_VALUE = IS_CUSTOMER_VAL
  ? B2C_ID_NAME
  : IS_B2B_VAL && CLASS_TYPE === B2BCLASSTYPE_B_ID
  ? B2BCLASSTYPE_B_ID_NAME
  : IS_B2B_VAL && CLASS_TYPE === B2BCLASSTYPE_N_ID
  ? B2BCLASSTYPE_N_ID_NAME
  : IS_B2B_VAL && CLASS_TYPE === B2BCLASSTYPE_C_ID
  ? B2BCLASSTYPE_C_ID_NAME
  : IS_B2B_VAL && CLASS_TYPE === B2BCLASSTYPE_E_ID
  ? B2BCLASSTYPE_E_NAME
  : IS_B2B_VAL && CLASS_TYPE === B2BCLASSTYPE_S_ID
  ? B2BCLASSTYPE_S_NAME
  : "Guest";

export const CLASS_VALUE_ID = IS_CUSTOMER_VAL
  ? B2C_ID
  : IS_B2B_VAL && CLASS_TYPE === B2BCLASSTYPE_B_ID
  ? B2BCLASSTYPE_B_ID
  : IS_B2B_VAL && CLASS_TYPE === B2BCLASSTYPE_N_ID
  ? B2BCLASSTYPE_N_ID
  : IS_B2B_VAL && CLASS_TYPE === B2BCLASSTYPE_C_ID
  ? B2BCLASSTYPE_C_ID
  : IS_B2B_VAL && CLASS_TYPE === B2BCLASSTYPE_E_ID
  ? B2BCLASSTYPE_E_ID
  : IS_B2B_VAL && CLASS_TYPE === B2BCLASSTYPE_S_ID
  ? B2BCLASSTYPE_S_ID
  : IS_B2B_VAL && CLASS_TYPE === SUPPLIER_ID
  ? SUPPLIER_ID
  : IS_B2B_VAL && CLASS_TYPE === STUDENT_ID
  ? STUDENT_ID
  : IS_B2B_VAL && CLASS_TYPE === AFFILIATED_EMPLOYEE_ID
  ? AFFILIATED_EMPLOYEE_ID
  : IS_B2B_VAL && CLASS_TYPE === AFFILIATED_MEMBER_ID
  ? AFFILIATED_MEMBER_ID
  : GUEST_ID;

export const CLASS_TYPE_NAME = IS_CUSTOMER_VAL
  ? B2C_ID_NAME
  : CLASS_TYPE === B2BCLASSTYPE_B_ID
  ? B2BCLASSTYPE_B_ID_NAME
  : CLASS_TYPE === B2BCLASSTYPE_N_ID
  ? B2BCLASSTYPE_N_ID_NAME
  : CLASS_TYPE === B2BCLASSTYPE_C_ID
  ? B2BCLASSTYPE_C_ID_NAME
  : CLASS_TYPE === B2BCLASSTYPE_E_ID
  ? B2BCLASSTYPE_E_NAME
  : CLASS_TYPE === B2BCLASSTYPE_S_ID
  ? B2BCLASSTYPE_S_NAME
  : CLASS_TYPE === SUPPLIER_ID
  ? SUPPLIER_NAME
  : CLASS_TYPE === STUDENT_ID
  ? STUDENT_NAME
  : CLASS_TYPE === AFFILIATED_EMPLOYEE_ID
  ? AFFILIATED_EMPLOYEE_NAME
  : CLASS_TYPE === AFFILIATED_MEMBER_ID
  ? AFFILIATED_MEMBER_NAME
  : "Guest";

export function getClassTypeName() {
  return CLASS_TYPE_NAME;
}

const B2B_SHOW_PASSENGER_CONTACT_CLASS_TYPES = new Set([
  B2BCLASSTYPE_N_ID,
  B2C_ID,
  B2BCLASSTYPE_C_ID,
  GUEST_ID,
  B2BCLASSTYPE_E_ID,
  B2BCLASSTYPE_S_ID,
]);

export const shouldHidePassengerContactFields = () => {
  const classType = localStorage.getItem(B2B_ClASS_TYPE);

  if (localStorage.getItem(IS_B2B) === "yes") {
    return !B2B_SHOW_PASSENGER_CONTACT_CLASS_TYPES.has(classType);
  }

  return (
    localStorage.getItem(IS_EMPLOYEE) === "yes" &&
    classType === B2BCLASSTYPE_B_ID
  );
};

export const isEmployeeClassBBooking = shouldHidePassengerContactFields;
